import axios from 'axios';
import { datadogLogs } from '@datadog/browser-logs';

/**
 * Will log the error to Datadog so long as the error is not a status response error from axios, or an axios generic
 * 'Network Error'.
 * @param error The error which was thrown.
 */
const logErrorToDatadogExcludingNetworkingErrors = (error) => {
  // istanbul ignore else
  if (error) {
    const isNetworkingError =
      (error.response && error.response.status) || (error.message && error.message.toLowerCase() === 'network error');

    if (!isNetworkingError) {
      datadogLogs.logger.error(error.message);
    }
  }
};

export default {
  makeGetRequest: (url, requestParams = {}) => {
    return new Promise((resolve, reject) => {
      axios
        .get(url, requestParams)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          logErrorToDatadogExcludingNetworkingErrors(err);
          reject(err);
        });
    });
  },

  makePutRequest: (url, payload, requestParams = {}) => {
    return new Promise((resolve, reject) => {
      axios
        .put(url, payload, requestParams)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          logErrorToDatadogExcludingNetworkingErrors(err);
          reject(err);
        });
    });
  },

  makePostRequest: (url, payload, config) => {
    return new Promise((resolve, reject) => {
      axios
        .post(url, payload, config)
        .then((response) => {
          resolve(response.data);
        })
        .catch((err) => {
          logErrorToDatadogExcludingNetworkingErrors(err);
          reject(err);
        });
    });
  },
};
